<template>
    <div class="icon-clac">
        <p class="icon-wrapper bg1 clearfix">
            <span class="icon-desc fl">余额</span>
            <span class="icon-num fr">{{ remain | numDevide100 }}</span>
        </p>
        <span class="icon-symbol">=</span>
        <p class="icon-wrapper bg2 clearfix">
            <span class="icon-desc fl">总收入</span>
            <span class="icon-num fr">{{ incom | numDevide100 }}</span>
        </p>
        <span class="icon-symbol ">-</span>
        <p class="icon-wrapper bg2 clearfix">
            <span class="icon-desc fl">总支出</span>
            <span class="icon-num fr">{{ (Math.abs(distribution)) | numDevide100 }}</span>
        </p>
    </div>
</template>
<script>
    export default {
        props: {
            incom: {
                type: Number,
                default: 0,
            },
            distribution: {
                type: Number,
                default: 0,
            },
            remain: {
                type: Number,
                default: 0,
            },
        },
        data: () => ({}),
        created() {},
        methods: {},
    };
</script>
<style lang="less" scoped>
.icon-clac {
    margin: 15px 0;
    .bg1 {
        background: #e79152;
    }
    .bg2 {
        background: #45ced4;
    }
    .icon-wrapper {
        display: inline-block;
        box-sizing: border-box;
        min-width: 188px;
        height: 60px;
        border-radius: 6px;
        color: #ffffff;
        padding: 0 20px;
        vertical-align: top;
        .icon-desc {
            display: inline-block;
            line-height: 60px;
            height: 60px;
            font-size: 14px;
        }
        .icon-num {
            display: inline-block;
            height: 60px;
            line-height: 60px;
            font-size: 22px;
            margin-left: 10px;
        }
    }
    .icon-symbol {
        display: inline-block;
        line-height: 60px;
        height: 60px;
        font-size: 22px;
        margin: 0 25px;
    }
}
</style>
